import { useCallback, useRef } from 'react';
import { usePost } from '../../../API';

export const useFieldValueSuggestions = () => {
  const fetchFieldValuesAPI = usePost('/api/admin_panel/field_values');
  const fetchAPIRef = useRef(fetchFieldValuesAPI);
  
  // Keep ref updated but don't trigger re-memoization
  fetchAPIRef.current = fetchFieldValuesAPI;

  const fetchSuggestions = useCallback(async (field: string, search: string): Promise<string[]> => {
    try {
      const response = await fetchAPIRef.current({
        field,
        search: search || undefined,
        limit: 20
      });

      if (response.success && response.data) {
        return response.data.values || [];
      }
      
      return [];
    } catch (err) {
      console.error('Error fetching field value suggestions:', err);
      return [];
    }
  }, []);

  return {
    fetchSuggestions
  };
};
